<template>
	<section class="page page-tv">
		<SceneTV v-bind:scheduleCollection="scheduleCollection" v-bind:scheduleModel="scheduleModel" />
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageTV extends PageBase {
		/**
		 * @type ChalkySticks.Collection.Schedule
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Schedule.collection(),
		})
		public scheduleCollection!: ChalkySticks.Collection.Schedule;

		/**
		 * @type ChalkySticks/Model/Schedule
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Schedule.model(),
		})
		public scheduleModel!: ChalkySticks.Model.Schedule;
	}
</script>

<style lang="scss">
	.page-tv {
		background-color: var(--chalky-blue);
		z-index: var(--z-page-bottom); // sit above the pad combo
	}

	// State
	// ---------------------------------------------------------------------------

	@media (orientation: landscape) {
		#app[page*='PageTV'] {
			--global-tab-height: 0;

			#GlobalNavigationTabs {
				display: none;
			}
		}
	}
</style>
